import React from "react";
import { PersonInfoList } from "components/person-info/PersonInfoList";
import { Provider } from "components/person-info/PersonInfoContext";

export const PersonInfos = () => {
    return (
        <Provider>
            <PersonInfoList />
        </Provider>
    );
};
